import { render, staticRenderFns } from "./OnSitePurchasesTable.vue?vue&type=template&id=114b1966&scoped=true"
import script from "./OnSitePurchasesTable.vue?vue&type=script&lang=js"
export * from "./OnSitePurchasesTable.vue?vue&type=script&lang=js"
import style0 from "./OnSitePurchasesTable.vue?vue&type=style&index=0&id=114b1966&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114b1966",
  null
  
)

export default component.exports